'use strict';

intellidealerAppCoreModule.controller('DashboardNotificationWidgetController', function ($scope) {
  $scope.alertHistory = $scope.slide.model;
});
